// Custom, in-brand Cookie Policy — replaces the Iubenda-hosted page.
// DRAFT compiled from the project's actual cookie/storage usage.
// ⚠️ Have this reviewed by counsel before relying on it in production.
import { Link } from "react-router-dom";

const UPDATED = "24 June 2026";

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2
        className="text-2xl md:text-3xl metal-gold-text mb-4"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        {title}
      </h2>
      <div className="space-y-3 text-sm md:text-[15px] leading-relaxed text-[#A1A1A1]">
        {children}
      </div>
    </section>
  );
}

function CookieRow({ name, provider, purpose, duration, type }) {
  return (
    <tr className="border-b border-[#1A1A1A] align-top">
      <td className="py-3 pr-4 text-[#EAEAEA] whitespace-nowrap">{name}</td>
      <td className="py-3 pr-4 text-[#A1A1A1]">{provider}</td>
      <td className="py-3 pr-4 text-[#A1A1A1]">{purpose}</td>
      <td className="py-3 pr-4 text-[#A1A1A1] whitespace-nowrap">{duration}</td>
      <td className="py-3 text-[#A1A1A1] whitespace-nowrap">{type}</td>
    </tr>
  );
}

export default function CookiePolicy() {
  const openPrefs = () => {
    if (window._iub && window._iub.cs && window._iub.cs.api) {
      window._iub.cs.api.openPreferences();
    }
  };
  return (
    <div className="min-h-screen pt-28 md:pt-36 pb-24 px-6">
      <div className="max-w-3xl mx-auto">
        <p className="text-[10px] tracking-[0.4em] uppercase metal-gold-text mb-3">Legal</p>
        <h1
          className="text-4xl md:text-5xl text-[#EAEAEA] mb-2"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Cookie Policy
        </h1>
        <p className="text-xs text-[#737373] mb-12">Last updated: {UPDATED}</p>

        <Section title="What cookies are">
          <p>
            Cookies and similar technologies (local/session storage) are small pieces of
            data stored in your browser. We keep our use deliberately minimal — no
            advertising or cross-site tracking cookies.
          </p>
        </Section>

        <Section title="Cookies & storage we use">
          <div className="overflow-x-auto">
            <table className="w-full text-xs md:text-sm border-collapse">
              <thead>
                <tr className="border-b border-gold/30 text-left">
                  <th className="py-2 pr-4 text-[10px] tracking-[0.2em] uppercase text-[#737373]">Name</th>
                  <th className="py-2 pr-4 text-[10px] tracking-[0.2em] uppercase text-[#737373]">Provider</th>
                  <th className="py-2 pr-4 text-[10px] tracking-[0.2em] uppercase text-[#737373]">Purpose</th>
                  <th className="py-2 pr-4 text-[10px] tracking-[0.2em] uppercase text-[#737373]">Duration</th>
                  <th className="py-2 text-[10px] tracking-[0.2em] uppercase text-[#737373]">Type</th>
                </tr>
              </thead>
              <tbody>
                <CookieRow name="_iub / euconsent" provider="Iubenda" purpose="Stores your cookie-consent choices." duration="up to 12 months" type="Necessary" />
                <CookieRow name="ss_cart / ss_checkout_email" provider="Sanctum (this site)" purpose="Remembers your cart and pre-fills your email at checkout. Stored in your browser's session storage." duration="Session" type="Functional" />
                <CookieRow name="sanctum_admin_token" provider="Sanctum (this site)" purpose="Keeps an authenticated admin logged in. Set only inside the admin panel." duration="Session" type="Necessary" />
                <CookieRow name="ph_* " provider="PostHog" purpose="Product analytics — set ONLY after you accept the “Measurement” purpose. Form inputs are masked." duration="up to 12 months" type="Analytics (consent)" />
              </tbody>
            </table>
          </div>
        </Section>

        <Section title="Managing your consent">
          <p>
            Analytics cookies load only after you accept them in the consent banner. You can
            review or change your choices at any time:
          </p>
          <button
            type="button"
            onClick={openPrefs}
            className="metal-gold-surface px-6 py-2.5 rounded-full text-xs tracking-[0.2em] uppercase font-semibold mt-2 hover:brightness-105"
          >
            Manage Cookies
          </button>
          <p className="mt-3">
            You can also block or delete cookies through your browser settings; some site
            features may then not work as intended.
          </p>
        </Section>

        <Section title="More information">
          <p>
            How we handle personal data overall is described in our{" "}
            <Link className="text-gold hover:underline" to="/privacy">Privacy Policy</Link>.
            Questions? Email{" "}
            <a className="text-gold hover:underline" href="mailto:privacy@sanctumsonics.com">
              privacy@sanctumsonics.com
            </a>
            .
          </p>
        </Section>

        <div className="mt-14 pt-8 border-t border-[#1A1A1A]">
          <Link to="/" className="text-[10px] tracking-[0.3em] uppercase metal-gold-text hover:brightness-125">
            ← Back to Sanctum Sonics
          </Link>
        </div>
      </div>
    </div>
  );
}
